var axios = require('axios')
const urlCategory = process.env.version2 + '/product-menu-fe/category'
const urlMenu = process.env.version2 + '/product-menu-fe/menu'
const urlSlice = process.env.version + '/product-customer/slice_info'
const urlSliceHistory = process.env.version + '/product-customer/slice_grant_history'
const urlSliceExpired = process.env.version + '/product-customer/slice_expired'
const urlEvent = process.env.version + '/product-customer/jp-loyalty-events'

axios.getCategoryLoyalty = function (params, success, callBackError) {
  this.get(urlCategory, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getAllCategoryLoyalty = async function (params) {
  try {
    const result = await this.get(urlCategory, {params})
    if (result.status === 200 && result.data) {
      return result
    }
  } catch (error) {
    console.log(error)
  }
  return null
}

axios.getFreeItemsLoyalty = async function (params) {
  try {
    const result = await this.get(urlMenu, {params})
    if (result.status === 200 && result.data) {
      return result
    }
  } catch (error) {
    console.log(error)
  }
  return null
}

axios.getItemsLoyalty = function (params, success, callBackError) {
  this.get(urlMenu, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getSliceInfo = function (params, success, callBackError) {
  this.get(urlSlice, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getSliceHistory = function (params, success, callBackError) {
  this.get(urlSliceHistory, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getEventLoyalty = function (params, success, callBackError) {
  this.get(urlEvent, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.deleteEventLoyalty = function (params, success, callBackError) {
  this.delete(urlEvent + '/' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getSliceExpired = function (params, success, callBackError) {
  this.get(urlSliceExpired, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/api/Loyalty.js